import { RouteRecordRaw } from 'vue-router'
import { WebsitePaths } from './path.constants'

const routes: RouteRecordRaw[] = [
  { // Route as above but doesn't require authentication
    path: '/',
    meta: {
      requiresAuth: false
    },
    component: () => import('src/areas/notLoggedIn/layouts/Default.vue'),
    children: [
      {
        // A full page load of `/` never reaches the router: src-ssr/extension.js answers it with a 302
        // to the reviewer app's review-copies list [sc-28009]. This only catches an in-app navigation
        // to the root, and sends it to the author landing page the root used to be.
        path: WebsitePaths.home,
        redirect: WebsitePaths.authors
      },
      {
        path: WebsitePaths.authors,
        meta: { metaInstructions: { module: 'websiteAuthors' } },
        component: () => import('src/areas/notLoggedIn/pages/Index.vue')
      },
      {
        path: WebsitePaths.about,
        meta: { metaInstructions: { module: 'websiteAbout' } },
        component: () => import('src/areas/notLoggedIn/pages/About.vue')
      },
      {
        path: WebsitePaths.pricing,
        meta: { metaInstructions: { module: 'websitePricing' } },
        component: () => import('src/areas/notLoggedIn/pages/Plans.vue')
      },
      {
        path: WebsitePaths.privacyPolicy,
        meta: { metaInstructions: { module: 'websitePrivacyPolicy' } },
        component: () => import('src/areas/notLoggedIn/pages/PrivacyPolicy.vue')
      },
      {
        path: WebsitePaths.terms,
        meta: { metaInstructions: { module: 'websiteTerms' } },
        component: () => import('src/areas/notLoggedIn/pages/Terms.vue')
      },
      {
        path: WebsitePaths.affiliateDisclosure,
        meta: { metaInstructions: { module: 'websiteAffiliateDisclosure' } },
        component: () => import('src/areas/notLoggedIn/pages/AffiliateDisclosure.vue')
      },
      {
        path: WebsitePaths.cookiePolicy,
        meta: { metaInstructions: { module: 'websiteCookiePolicy' } },
        component: () => import('src/areas/notLoggedIn/pages/CookiePolicy.vue')
      },
      {
        path: WebsitePaths.privacyPolicyAllProducts,
        meta: { metaInstructions: { module: 'websitePrivacyPolicyAllProducts' } },
        component: () => import('src/areas/notLoggedIn/pages/PrivacyPolicyAllProducts.vue')
      },
      {
        path: WebsitePaths.affiliateProgram,
        meta: { metaInstructions: { module: 'websiteAffiliateProgram' } },
        component: () => import('src/areas/notLoggedIn/pages/AffiliateProgram.vue')
      },
      {
        path: WebsitePaths.affiliateTermsAndConditions,
        meta: { metaInstructions: { module: 'websiteAffiliateTermsAndConditions' } },
        component: () => import('src/areas/notLoggedIn/pages/AffiliateTermsAndConditions.vue')
      }
    ]
  }
]

routes.push({
  /**
   * `/:catchAll(.*)*`, not `'*'`: vue-router 4 removed the bare wildcard in favour of a named
   * param with a custom regexp. A route still declaring `'*'` never matches anything.
   */
  path: '/:catchAll(.*)*',
  component: () => import('src/areas/notLoggedIn/pages/httpError/404.vue')
})

export default routes
